"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.formatAddonPrice = void 0;
exports.getUIFilteredAddons = getUIFilteredAddons;
var _constants = require("../constants");
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
function getUIFilteredAddons(addOns, uiType) {
  return (0, _filter2.default)(addOns, function (addOn) {
    return addOn.uiType === uiType;
  });
}
var formatAddonPrice = exports.formatAddonPrice = function formatAddonPrice(_ref) {
  var currencyStore = _ref.currencyStore,
    price = _ref.price;
  var shouldRoundPrice = (0, _includes2.default)(_constants.ADDON_CURRENCY_ROUNDUP, currencyStore.currentCurrency);
  return !shouldRoundPrice ? currencyStore.convertAndFormatPriceValue({
    price: price
  }) : currencyStore.convertCeilAndFormatPrice({
    price: price,
    decimal: 0
  });
};